import script from "./TheControls.vue?vue&type=script&setup=true&lang=js"
export * from "./TheControls.vue?vue&type=script&setup=true&lang=js"

import "./TheControls.vue?vue&type=style&index=0&id=47d69794&lang=css"

const __exports__ = script;

export default __exports__